import React from 'react';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useTranslate } from 'ra-core';
import { ModalBlock } from '../../components/Modal';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    outline: 'none',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
  },
  modalBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
  },
}));

export const ModalConfirm = ({ open, onCancel, onAccept }) => {
  const classes = useStyles();
  const translate = useTranslate();

  return (
    <ModalBlock open={open} title="Warning">
      <p>{translate('resources.contracts.messages.edit_warning')}</p>
      <div className={classes.modalBtn}>
        <Button variant="contained" style={{ backgroundColor: '#f48fb1' }} color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={() => onAccept()}>
          Ok
        </Button>
      </div>
    </ModalBlock>
  );
};
